var exports = {
  "kL": "xfd349460--d1a4e0--container",
  "Dy": "xfd349460--d1a4e0--names",
  "x8": "xfd349460--d1a4e0--names-text",
  "x6": "xfd349460--d1a4e0--button",
};

module.exports = exports;
